import angular from 'angular';
import quotationsModule from './quotations/quotations';
import serviceOrdersModule from './service-orders/service-orders';
import paymentOrdersModule from './payment-orders/payment-orders';

let paymentsAdvancesModule = angular.module('app.paymentsAdvances',[
  quotationsModule.name,
  serviceOrdersModule.name,
  paymentOrdersModule.name
]);

export default paymentsAdvancesModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/payments-advances/payments-advances.js
 **/